import {
  VALIDATE_TOKEN_FAILURE,
  VALIDATE_TOKEN_REQUEST,
  VALIDATE_TOKEN_SUCCESS,
} from "./actionTypes";

const initialState = {
  loading: true,
  isAuthenticated: false,
  error: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case VALIDATE_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case VALIDATE_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        error: null,
      };
    case VALIDATE_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
